import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Products from "./pages/Products";
import AboutUs from "./pages/AboutUs";
import Resources from "./pages/Resources";
import ContactUs from "./pages/ContactUs";
import RoomVisualizer from "./pages/RoomVisualizer";
import RequestQuote from "./pages/RequestQuote";
import BecomeDistributor from "./pages/BecomeDistributor";
import ScrollToTop from "./components/ScrollToTop";
import { Toaster } from "./components/ui/toaster";
import "./App.css";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/products" element={<Products />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/resources" element={<Resources />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/visualizer" element={<RoomVisualizer />} />
          <Route path="/request-quote" element={<RequestQuote />} />
          <Route path="/become-distributor" element={<BecomeDistributor />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
